"use client";

import { Spinner } from "./ui/spinner";

export const Loading = () => {
  return <Spinner size="large">Loading...</Spinner>;
};
